import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DropdownItem, DropdownMenu } from "reactstrap";
import "assets/styles/components/dropdown.scss";
import { COINNIK_MARKET_APP_URL } from "configs/constants";

function Support() {
  const { t } = useTranslation();
  return (
    <>
      <DropdownItem className="pb-2" href="tel://+982147612345">
        <div className="d-flex align-items-center  d-none d-sm-block">
          <span className="px-3 ">{t("02147612345")}</span>
          <i className="icon-phone-color " />
        </div>
      </DropdownItem>
      <DropdownItem href={`${COINNIK_MARKET_APP_URL}tickets/list`}>
        <div className="d-flex align-items-center  ">
          <i className="icon-forum" />
          <span className="px-3 ">{t("Send a ticket")}</span>
        </div>
      </DropdownItem>
      <DropdownItem divider className="mx-3 mt-3 mb-3" />
      <DropdownItem tag={Link} to="/contact-us" className="pb-2 ">
        <div className="d-flex align-items-center  ">
          <i className="icon-contact-phone " />
          <span className="px-3 ">{t("Contact Us")}</span>
        </div>
      </DropdownItem>
      <DropdownItem tag={Link} to="/faq" className="pb-2 ">
        <div className="d-flex align-items-center  ">
          <i className="icon-question" />
          <span className="px-3 ">{t("Frequently Asked Questions")}</span>
        </div>
      </DropdownItem>
      <DropdownItem to="/user-guide" tag={Link}>
        <div className="d-flex align-items-center pb-2 ">
          <i className="icon-document " />
          <span className="px-3 ">{t("user manual")}</span>
        </div>
      </DropdownItem>
    </>
  );
}

export default Support;
